module.exports = "https://static.wagwalking.com/_next/static/images/boarding-b0655ca4d66c13657e12d2745e080ccc.svg";